import { useHeaderHeight } from '@react-navigation/elements';
import { LinearGradient } from 'expo-linear-gradient';
import React, { useEffect } from 'react';
import { Image } from 'react-native';

import { Assets } from 'src/assets';
import { useTripInfoState } from 'src/common/hooks/states/useTripInfoState';
import { useTripDetailQuery } from 'src/common/hooks/useTripDetailQuery';
import { errorHandler } from 'src/common/utils/ErrorHandler';
import { Center, Container, EmptyState, FooterButton, TripDetailBody } from 'src/components';
import { Navigation } from 'src/navigations/RootNavigation';
import { device, metrics, pixelScaler } from 'src/themes/Metrics';

const TripDetailScreen = () => {
  const { departureTripInfo, returnTripInfo } = useTripInfoState();
  const { data, isLoading, isError, error } = useTripDetailQuery({ tripId: departureTripInfo?.tripId });
  // const { data, isLoading, isError, error } = useTripDetailQuery({ tripId: '1' });

  const headerHeight = useHeaderHeight();

  useEffect(() => {
    if (isError) {
      errorHandler({ error });
    }
  }, [isError]);

  // if (isError) {
  //   return <View />;
  // }

  const handleBookNowPress = () => {
    if (returnTripInfo) {
      // round trip
      Navigation.navigate('ReturnSelectSeatScreen');
    } else {
      Navigation.navigate('SelectSeatScreen');
    }
  };

  return (
    <Container flex backgroundColor="white">
      {isLoading || isError ? (
        <Center flex>
          <EmptyState loading={isLoading} error={error} text="tripEmptyContent" />
        </Center>
      ) : (
        <>
          <Container style={{ zIndex: 999 }}>
            <Image
              resizeMode="cover"
              source={data.coverImag ? { uri: data.coverImag } : Assets.TripDetailHeader}
              style={{ height: pixelScaler(160), width: '100%' }}
            />
          </Container>
          <Container paddingTop={metrics.large} flex>
            <TripDetailBody tripDetailInfo={data} />
          </Container>
          <FooterButton text="bookNow" onPress={handleBookNowPress} />
        </>
      )}
      <LinearGradient
        colors={['rgba(0,0,0,0.75)', 'transparent']}
        style={{
          height: headerHeight,
          width: device.width,
          position: 'absolute',
          top: 0,
          left: 0,
          zIndex: 999,
        }}
      />
      {/* <Container
        width="100%"
        style={{ position: 'absolute', top: 0, left: 0, zIndex: 999 }}
        height={headerHeight}
        backgroundColor="rgba(0,0,0,0.2)"
      /> */}
    </Container>
  );
};

export default TripDetailScreen;
